enum LoaderType {
  Linear = "linear",
  Circular = "circular",
}

export { LoaderType };
